import { Api } from "../Api";
import { IUser } from "../models/IUser";

class UserApi {
  static list(signal?: AbortSignal): Promise<IUser[]> {
    return Api.Get<IUser[]>("api/users", signal);
  }

  static get(uuid: string, signal?: AbortSignal): Promise<IUser> {
    return Api.Get<IUser>(`api/user/${uuid}`, signal);
  }

  static create(user: IUser, signal?: AbortSignal): Promise<IUser> {
    return Api.Post<IUser>(`api/user`, user, signal);
  }

  static update(user: IUser, signal?: AbortSignal): Promise<IUser>{
    return Api.Put<IUser>(`api/user/${user.uuid}`, user, signal);
  }

  static delete(uuid: string, signal?: AbortSignal): Promise<IUser>{
    return Api.Delete<IUser>(`api/user/${uuid}`, signal);
  }
}

export { UserApi }
